import { Package, PackageHost } from '../../Container';
import { inTool } from '../../canvas/tooling/ToolManager';
import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inConnectorCommands } from './ConnectorCommands';
import { ConnectorMechanics } from './ConnectorMechanics';
import { connectorTool } from './ConnectorTool';
import { connectorToolboxItem } from './ConnectorToolboxItem';

export class ConnectorPackage implements Package {

    public install = (host: PackageHost) => host
        .register(ConnectorMechanics, 'singleton', 'startable')
        .plug(inConnectorCommands())
        .plug(inTool(connectorTool))
        .plug(inToolboxItems(connectorToolboxItem))
        ;
}
